import React from 'react';
import '../Css_files/Homecont4.css';

const HomeCont4 = () => {
  return (
    <div className="homecont4">
      <div className="background-iframehead"> 
        <h2 className="section-title">
          Hear Why Students <span>Choose Profenaa Online</span>
        </h2>

        <p className="section-subtext">
          A decision that transforms your skills and career. Profenaa Technologies Online Learning 
          empowers students globally with expert-led courses, practical projects, and career guidance.
        </p>
      </div>  
      <br />

      <h3 className="section-highlight">
        Real Stories, Real Impact
      </h3>

      <div className="video-description-container">
        <div className="video-wrapper">
          <div className="responsive-video-container">
            <iframe
              src="https://www.youtube.com/embed/CHQsmOqm4xw?si=G2G7edA-f_P5yJ_4"
              title="Student Testimonials"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="description-text">
          <p>
            Hear directly from our students about how Profenaa Online transformed their learning journey. 
            From mastering technical skills to gaining industry-ready experience, our learners share their 
            successes, challenges, and career breakthroughs.  
            <br /><br />
            Join thousands of learners worldwide who trusted Profenaa Technologies Online Learning 
            to turn their passion into profession. Your story could be the next success we celebrate!
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomeCont4;
